var _path, _path2, _g, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHarvest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6045 37.2949C20.6365 37.685 20.6365 38.1351 20.1886 38.3152C19.7407 38.4952 19.9327 38.0751 19.9966 37.8651C20.0606 37.655 20.3805 37.475 20.6045 37.2949Z",
    fill: "#491086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6045 37.2949C20.6666 37.1589 20.7415 37.0284 20.8284 36.9049C22.1721 34.6244 22.7799 32.4339 22.204 29.6434C21.3083 25.3224 24.2515 22.2918 29.6582 20.9715C32.3136 20.3114 35.0329 20.2514 37.7522 20.1914C38.392 20.1914 39.1278 20.1914 39.1279 21.0616C39.1279 21.3963 39.1293 21.7311 39.1308 22.0658C39.1447 25.211 39.1586 28.3492 37.9442 31.4138C35.8327 36.6048 30.1701 37.8051 25.5632 35.5846C24.4755 35.0445 24.1236 35.3145 23.7077 36.1847C21.8842 39.6955 21.2123 43.4763 21.0204 47.3471C21.0104 47.4637 21.0075 47.5853 21.0045 47.7074C20.9882 48.371 20.9715 49.0481 19.8367 48.9974C18.6602 48.9449 18.6855 48.2483 18.71 47.5722C18.7135 47.4761 18.717 47.3804 18.717 47.287C18.7367 43.0306 18.0899 38.7946 16.7974 34.7144C16.2215 32.884 15.9976 32.734 14.1421 33.1841C8.57543 34.4443 4.35246 31.9238 2.97679 26.7027C2.24245 23.9983 1.91934 21.2102 2.01703 18.421C2.01703 17.6108 2.30495 17.2207 3.20073 17.2207C6.81583 17.1607 10.3989 17.2507 13.8861 18.481C19.8046 20.5814 20.3805 26.0426 18.461 29.9734C17.9811 30.9336 17.8851 31.6538 18.365 32.584C19.2288 34.2643 19.6127 36.0647 19.9966 37.8651C20.389 38.0123 20.4204 37.8097 20.4525 37.6033C20.4727 37.4731 20.4931 37.3414 20.6045 37.2949ZM16.5735 29.1032C14.8779 26.9128 13.1823 25.2324 11.0388 23.9721C10.96 23.9228 10.8815 23.871 10.8034 23.8194C10.2159 23.4314 9.64452 23.0541 9.02331 23.8221C8.31949 24.6923 9.08731 25.3224 9.75914 25.7425C11.4476 26.787 12.9215 28.1084 14.1101 29.6433C14.7179 30.3935 14.6859 30.7536 13.5982 31.0536C9.72715 32.1339 6.59194 30.5135 5.34424 26.5527C4.67241 24.4822 4.48042 22.3518 4.32046 20.1913C4.25648 19.5012 4.48043 19.1711 5.28024 19.2311L5.58165 19.2549C8.1363 19.4559 10.6853 19.6564 13.0863 20.5514C16.1895 21.6917 17.4372 23.6721 16.9893 26.7627C16.929 27.1586 16.8561 27.5546 16.7626 28.0621C16.7073 28.3624 16.6448 28.7017 16.5735 29.1032ZM30.9379 22.9219C25.6592 23.9121 23.7397 26.3426 24.7315 30.8736C25.0592 30.6072 25.3645 30.3478 25.6602 30.0965C26.2305 29.6121 26.7649 29.1581 27.3548 28.7432C28.2616 28.1378 29.2013 27.5769 30.1701 27.0628C31.0019 26.5827 31.8977 26.2226 32.5055 27.2429C33.0378 28.1363 32.2698 28.5004 31.598 28.819C31.5027 28.8642 31.4093 28.9085 31.3218 28.9532C29.5302 29.8362 27.8996 30.9807 26.491 32.3439C26.0751 32.794 25.7232 33.1841 26.491 33.6642C29.4023 35.4346 34.0731 34.2043 35.5128 31.2037C36.7285 28.6532 36.9524 25.9226 37.1444 23.162C37.2077 22.3896 36.7693 22.4113 36.1708 22.441L36.1526 22.4419C34.4042 22.4813 32.6612 22.6418 30.9379 22.9219Z",
    fill: "#491086"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12932_27516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 18.3327C28.9123 18.3327 32.0837 15.1614 32.0837 11.2493C32.0837 7.33733 28.9123 4.16602 25.0003 4.16602C21.0883 4.16602 17.917 7.33733 17.917 11.2493C17.917 15.1614 21.0883 18.3327 25.0003 18.3327Z",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1.66602H27.5",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 7.91602V11.2493",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 11.25H25",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 1.66602V3.33268",
    stroke: "#460F81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27L45 24L48 27",
    stroke: "#491086",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44H43.5C44.3285 44 45 43.2445 45 42.3125V26",
    stroke: "#491086",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12932_27516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarvest);
export default __webpack_public_path__ + "static/media/harvest.7f66771f0d994185dc1f60dcfa9d69db.svg";
export { ForwardRef as ReactComponent };